<div class="main-content">
  <div class="top-container">
    <div class="left-content">
      <div
        *ngIf="data | sectionRowViewModelBasicMethod: 'getRowTitle' as title"
        appPrintCardScaleDownText
        class="product-card-name"
        [maxHeightInPx]="20"
        [maxWidthInPx]="212"
        [adjustLineHeight]="false"
        [transparentWhileScaling]="true"
        [style.color]="viewModel.headerTextColor$ | async">
        {{ title | trimSafely }}
      </div>

      <div #brandAndLabelContainer class="brand-and-label-container">
        <div class="product-brand-wrapper">
          <div
            *ngIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand"
            appPrintCardScaleDownText
            class="product-card-brand"
            [maxHeightInPx]="14"
            [maxWidthInPx]="212"
            [adjustLineHeight]="false"
            [transparentWhileScaling]="true"
            [style.color]="viewModel.headerTextColor$ | async">
            {{ brand | uppercase }}
          </div>
        </div>

        <div>
          <app-label-inflator
            class="print-card-label"
            [columnLabel]="false"
            [labelComponentInterface]="data"
            [reset]="false">
          </app-label-inflator>
        </div>
      </div>
    </div>

    <div class="right-content">
      <div
        class="product-card-strain-type"
        *ngIf="viewModel.strainText$ | async as strainType"
        [style.background-color]="viewModel.cardAccentColor$ | async"
        [style.color]="viewModel.cardColor$ | async">
        {{ strainType | uppercase }}
      </div>

      <div
        *ngIf="
          (viewModel.atLeastOneGridVariantOnSale$ | async) &&
          (viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) : true : false | async) as size
        "
        class="product-card-size"
        [style.color]="viewModel.bodyTextColor$ | async">
        {{ size }}
      </div>
    </div>
  </div>

  <div class="bottom-container">
    <div class="cannabinoids-and-terpenes-container">
      <div #propertyColumn1 class="property-column">
        <ng-container *ngFor="let property of viewModel.firstColumnProperties$ | async">
          <div class="property-container">
            <div class="title" [style.color]="viewModel.bodyTextColor$ | async">{{ property?.title }}</div>
            <div
              #me1
              class="value"
              appPrintCardScaleDownText
              [maxWidthInPx]="me1.offsetWidth - 1"
              [maxHeightInPx]="16"
              [adjustLineHeight]="false"
              [startScalingAfterNMillisecondsAfterViewInit]="500"
              [transparentWhileScaling]="true"
              [style.color]="viewModel.bodyTextColor$ | async">
              {{ property?.value }}
            </div>
          </div>
        </ng-container>
      </div>

      <div class="property-column">
        <ng-container *ngFor="let property of viewModel.secondColumnProperties$ | async">
          <div class="property-container">
            <div class="title" [style.color]="viewModel.bodyTextColor$ | async">{{ property?.title }}</div>
            <div
              #me2
              class="value"
              appPrintCardScaleDownText
              [maxWidthInPx]="me2.offsetWidth - 1"
              [maxHeightInPx]="16"
              [adjustLineHeight]="false"
              [startScalingAfterNMillisecondsAfterViewInit]="500"
              [transparentWhileScalingDebounceTimeInMilliseconds]="501"
              [transparentWhileScaling]="true"
              [style.color]="viewModel.bodyTextColor$ | async">
              {{ property?.value }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div #rightSide class="badge-size-and-price-container">
      <div *ngIf="viewModel.hasBadges$ | async" class="badge-container">
        <img
          *ngFor="let variantBadge of data | printCardBadges"
          appImage
          class="product-card-badge"
          [asset]="variantBadge?.image"
          alt="badge"
          src="" />
      </div>

      <div class="size-and-price-container">
        <div
          *ngIf="
            !(viewModel.atLeastOneGridVariantOnSale$ | async) &&
            (viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) : true : false | async) as size
          "
          class="product-card-size"
          [style.color]="viewModel.bodyTextColor$ | async">
          {{ size }}
        </div>

        <div class="pricing-container" [style.color]="viewModel.bodyTextColor$ | async">
          <app-column-primary-price
            [menu]="viewModel.cardStackMenu$ | async"
            [section]="viewModel.cardStack$ | async"
            [colVm]="viewModel.spoofedColViewModel$ | async"
            [rowVm]="viewModel.cardData$ | async"
            [locConfig]="viewModel.locationConfig$ | async"
            [locationId]="viewModel.locationId$ | async"
            [productStylingVm]="viewModel">
          </app-column-primary-price>
        </div>
      </div>
    </div>
  </div>
</div>
